import { F as e, at as t, h as n, m as r, ot as i, t as a, v as o, w as s } from "./_plugin-vue_export-helper-CTQVpqU-.js";
//#region src/webcomponents/common/stepper/Stepper.ce.vue?vue&type=script&setup=true&lang.ts
var c = { class: "steps-wrapper" }, l = { class: "steps-wrapper__stepper" }, u = { "aria-hidden": "true" }, d = {
	class: "sr-only",
	"aria-live": "polite"
}, f = /*#__PURE__*/ a(/* @__PURE__ */ s({
	__name: "Stepper.ce",
	props: {
		step: { type: Number },
		stepsCount: { type: Number }
	},
	setup(a) {
		let s = a, f = r(() => s.step + 1), p = r(() => Math.floor(f.value / s.stepsCount * 100));
		return (r, s) => (e(), o("div", c, [
			n("div", l, [n("div", {
				class: "steps-wrapper__effective-steps",
				style: t({ "--stepIndex": `${p.value}%` })
			}, null, 4)]),
			n("p", u, i(f.value) + "/" + i(a.stepsCount), 1),
			n("p", d, i(r.$t("stepper.step", {
				step: f.value,
				stepsCount: a.stepsCount
			})), 1)
		]));
	}
}), [["styles", [".steps-wrapper{color:#613fdd;justify-content:center;align-items:center;gap:6px;width:100%;font-size:.875rem;font-weight:500;display:flex}.steps-wrapper p{text-wrap:nowrap;margin:0}.steps-wrapper__stepper{background:#e8eaed;border-radius:4px;width:100%;height:8px}.steps-wrapper__effective-steps{width:var(--stepIndex);background:#613fdd;border-radius:4px;height:8px}.sr-only{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}"]]]);
//#endregion
export { f as t };
